export default {
  'app.settings.menuMap.basic': 'Cài đặt cơ bản',
  'app.settings.menuMap.security': 'Cài đặt bảo mật',
  'app.settings.menuMap.binding': 'Liên kết tài khoản',
  'app.settings.menuMap.notification': 'Thông báo tin nhắn mới',
  'app.settings.basic.avatar': 'Ảnh đại diện',
  'app.settings.basic.change-avatar': 'Đổi ảnh đại diện',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Vui lòng nhập email!',
  'app.settings.basic.nickname': 'Biệt danh',
  'app.settings.basic.nickname-message': 'Vui lòng nhập biệt danh!',
  'app.settings.basic.profile': 'Giới thiệu bản thân',
  'app.settings.basic.profile-message': 'Vui lòng nhập giới thiệu!',
  'app.settings.basic.profile-placeholder': 'Giới thiệu ngắn về bản thân',
  'app.settings.basic.country': 'Quốc gia/Vùng',
  'app.settings.basic.country-message': 'Vui lòng nhập quốc gia!',
  'app.settings.basic.geographic': 'Tỉnh/Thành phố',
  'app.settings.basic.geographic-message': 'Vui lòng nhập thông tin địa lý!',
  'app.settings.basic.address': 'Địa chỉ',
  'app.settings.basic.address-message': 'Vui lòng nhập địa chỉ!',
  'app.settings.basic.phone': 'Số điện thoại',
  'app.settings.basic.phone-message': 'Vui lòng nhập số điện thoại!',
  'app.settings.basic.update': 'Cập nhật thông tin',
  'app.settings.security.strong': 'Mạnh',
  'app.settings.security.medium': 'Trung bình',
  'app.settings.security.weak': 'Yếu',
  'app.settings.security.password': 'Mật khẩu tài khoản',
  'app.settings.security.password-description': 'Độ mạnh mật khẩu hiện tại',
  'app.settings.security.phone': 'Điện thoại bảo mật',
  'app.settings.security.phone-description': 'Điện thoại đã liên kết',
  'app.settings.security.question': 'Câu hỏi bảo mật',
  'app.settings.security.question-description': 'Câu hỏi bảo mật chưa được thiết lập',
  'app.settings.security.email': 'Email dự phòng',
  'app.settings.security.email-description': 'Email đã liên kết',
  'app.settings.security.mfa': 'Thiết bị MFA',
  'app.settings.security.mfa-description': 'Chưa liên kết thiết bị MFA',
  'app.settings.security.modify': 'Sửa',
  'app.settings.security.set': 'Thiết lập',
  'app.settings.security.bind': 'Liên kết',
  'app.settings.binding.taobao': 'Liên kết Taobao',
  'app.settings.binding.taobao-description': 'Chưa liên kết tài khoản Taobao',
  'app.settings.binding.alipay': 'Liên kết Alipay',
  'app.settings.binding.alipay-description': 'Chưa liên kết tài khoản Alipay',
  'app.settings.binding.dingding': 'Liên kết DingTalk',
  'app.settings.binding.dingding-description': 'Chưa liên kết tài khoản DingTalk',
  'app.settings.binding.bind': 'Liên kết',
  'app.settings.notification.password': 'Mật khẩu tài khoản',
  'app.settings.notification.password-description': 'Tin nhắn từ người dùng khác sẽ được thông báo',
  'app.settings.notification.messages': 'Tin nhắn hệ thống',
  'app.settings.notification.messages-description': 'Tin nhắn hệ thống sẽ được thông báo',
  'app.settings.notification.todo': 'Thông báo công việc',
  'app.settings.notification.todo-description': 'Danh sách công việc sẽ được thông báo',
  'app.settings.open': 'Bật',
  'app.settings.close': 'Tắt',
};
